import { Navigate, Outlet, useLocation } from "react-router-dom";
import tokenUtils from "utils/tokenUtils";
import routes from "constants/routes";

const AuthenticatedRoutes = () => {
  const location = useLocation();
  const { pathname, search } = location;

  const loggedIn = tokenUtils.isValidUser();

  if (!loggedIn) {
    return (
      <Navigate
        to={`${routes.login.root}?redirect=${encodeURIComponent(
          pathname + search,
        )}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default AuthenticatedRoutes;
